import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ImagePlaceholder } from './ImagePlaceholder';
const socialImages: {
  label: string;
  src?: string;
}[] = [{
  label: 'Mujer 1 sosteniendo ESBELTA',
  src: 'https://cdn.magicpatterns.com/uploads/7hXem2nH5SFAo7PE37E64Y/zzz.png'
}, {
  label: 'Mujer 2 sosteniendo ESBELTA',
  src: 'https://cdn.magicpatterns.com/uploads/mQaS7gX1FnCUsBNgQzPMNs/heylloyd-image-1781550705074.png'
}, {
  label: 'Mujer 3 sosteniendo ESBELTA',
  src: 'https://cdn.magicpatterns.com/uploads/pUPtfcTKETGohLMTeSsEHs/heylloyd-image-1781550763893.png'
}, {
  label: 'Mujer 4 sosteniendo ESBELTA',
  src: 'https://cdn.magicpatterns.com/uploads/nqBcwsZ55sa9tK1cKr7NfL/heylloyd-image-1781550832308.png'
}, {
  label: 'Mujer 5 sosteniendo ESBELTA',
  src: 'https://cdn.magicpatterns.com/uploads/kGEXo8S2tzExuGeaNjr2ke/heylloyd-image-1781550929158.png'
}, {
  label: 'Mujer 6 sosteniendo ESBELTA',
  src: 'https://cdn.magicpatterns.com/uploads/8Xi3WE5fHhjpLcha9ZAXsv/heylloyd-image-1781551031413.png'
}];
export function PruebaSocial() {
  return <section className="bg-esbelta-lavender/40 py-16 overflow-hidden" data-id="element-209">
      <div className="max-w-6xl mx-auto px-4 text-center mb-10" data-id="element-210">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-211">
          Ellas ya dieron el primer paso 💜
        </h2>
        <p className="text-gray-600 font-medium" data-id="element-212">
          + Más de 2.800 mujeres argentinas satisfechas
        </p>
      </div>

      <div className="relative w-full flex overflow-hidden" data-id="element-213">
        <motion.div className="flex gap-4 px-4" animate={{
        x: [0, -1000]
      }} transition={{
        repeat: Infinity,
        ease: 'linear',
        duration: 30
      }} data-id="element-214">
          {[...Array(2)].map((_, i) => <Fragment key={i} data-id="element-215">
              {socialImages.map((img, num) => <div key={num} className="w-[250px] md:w-[300px] aspect-[4/5] flex-shrink-0 rounded-2xl overflow-hidden shadow-sm bg-white" data-id="element-216">
                  {img.src ? <img src={img.src} alt={img.label} className="w-full h-full object-cover" data-id="element-217" /> : <ImagePlaceholder label={img.label} className="w-full h-full" data-id="element-218" />}
                </div>)}
            </Fragment>)}
        </motion.div>
      </div>
    </section>;
}